<template>
<div class="container">
  <div class="item" @click="routeTo('main')">Main</div>
  <div class="item" @click="routeTo('quiz')">Q and A</div>
  <div class="item" @click="routeTo('table')">Table</div>
  <div class="item" @click="routeTo('tree')">Tree</div>
  <div class="item" @click="routeTo('random')">Random Algo</div>
</div>
</template>

<script>
export default {
  name: "TopBar",
  methods: {
    routeTo(path) {
      this.$router.push({name: path});
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  width: 80%;
  height: 60px;
  align-items: center;
  justify-content: space-around;
  background: lightgrey;
  border-radius: 60px;
  margin-top: 3px;
  margin-bottom: 10px;
  box-shadow: 2px 2px 3px rgba(10, 10, 10, .1);
}

.item {
  min-width: 80px;
  font-weight: bold;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

.item:hover {
  font-weight: bolder;
  color: #be6408;
}


</style>